import React, { useState } from 'react';
import { Switch, Loader } from '@rsos/base-components';
import { CheckBox } from '@rsos/components/capstone/base';
import { useKeywordTierActions, useKeywordTiers } from '@rsos/reduxDataStore';
import FetchErrorComponent from '../../DigitalAlertsSettings/DigitalAlertsBannerSettings/FetchErrorComponent';
import styles from '../../settings.module.css';

export const KeywordBannerSettings = () => {
  const { tierMap, tiers, error } = useKeywordTiers();
  const { update, disable, enable, refetch } = useKeywordTierActions();
  const [enabled, setEnabled] = useState(tiers.some(t => t.notifications));

  return (
    <div className={styles.card}>
      <div>
        <div className={styles.cardTitle}>Keyword Banners</div>
        <div className={styles.cardDescription}>
          Notify your agents with a banner when keyword topics are detected.
        </div>
      </div>
      {!tierMap ? (
        <Loader text="Fetching.." />
      ) : error ? (
        <FetchErrorComponent handleFetchAlertTypes={refetch} />
      ) : (
        <div>
          <div
            id="usersAlertTypes-checkbox-group"
            aria-labelledby="usersAlertTypes-checkbox-group"
            role="group"
          >
            <div className={styles.toggleBlock}>
              <span>Notification banners</span>
              <Switch
                dataName="keyword-banner-toggle"
                onOffLabel
                onClick={async () => {
                  await (enabled ? disable() : enable());
                  setEnabled(!enabled);
                }}
                isOn={enabled}
              />
            </div>

            <CheckBox
              label="Tier 1"
              isChecked={tierMap['tier-1']?.notifications}
              disabled={!enabled}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                update('tier-1', e.currentTarget.checked)
              }
            />
            <CheckBox
              label="Tier 2"
              isChecked={tierMap['tier-2']?.notifications}
              disabled={!enabled}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                update('tier-2', e.currentTarget.checked)
              }
            />
            <CheckBox
              label="Tier 3"
              isChecked={tierMap['tier-3']?.notifications}
              disabled={!enabled}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                update('tier-3', e.currentTarget.checked)
              }
            />
          </div>
        </div>
      )}
    </div>
  );
};
